import type { CandidateComment } from '@/services/api'

/**
 * Lo que pinta una fila del tab Comentarios (SRH-321).
 *
 * El back manda cada comentario con su etapa y lo que decidio quien lo
 * escribio; aqui se traduce al rotulo que pide el ticket: «Juan Pérez ·
 * Entrevista del solicitante · aprobó».
 */
export interface ComentarioDeLaFicha {
  autor: string
  tipo: string
  fecha?: string | null
  texto: string
}

const AUTOR_SIN_NOMBRE: Record<CandidateComment['stage'], string> = {
  hr_interview: 'Entrevistador',
  requester_interview: 'Solicitante',
  requester_decision: 'Solicitante',
  discard: 'Reclutamiento',
  returned: 'Reclutamiento',
  direction_decision: 'Dirección',
}

const ETAPA: Record<CandidateComment['stage'], string> = {
  hr_interview: 'Entrevista RH',
  requester_interview: 'Entrevista del solicitante',
  requester_decision: 'Decisión del solicitante',
  discard: 'Descarte',
  returned: 'Regreso al tablero',
  direction_decision: 'Decisión de Dirección',
}

const DECISION: Record<NonNullable<CandidateComment['action']>, string | null> = {
  approved: 'aprobó',
  rejected: 'rechazó',
  // El descarte ya se rotula como tal; repetirlo seria ruido.
  discarded: null,
}

export const tipoDelComentario = (c: CandidateComment): string =>
  [ETAPA[c.stage], c.action ? DECISION[c.action] : null, c.reason?.trim() || null]
    .filter(Boolean)
    .join(' · ')

export const comentariosDeLaFicha = (
  lista: CandidateComment[],
): ComentarioDeLaFicha[] =>
  lista.map((c) => ({
    autor: c.author?.trim() || AUTOR_SIN_NOMBRE[c.stage],
    tipo: tipoDelComentario(c),
    fecha: c.date,
    texto: c.text,
  }))
